export const PERMISSION_GROUPS = {
    DASHBOARDS: 'Dashboards',
    USERS: 'Users',
    BOOKINGS: 'bookings',
    SURVEYS: 'surveys',
    SALES: 'Sales',
    OTHERS: 'Others',
    RESPONDENTS: 'Respondents'
};
//# sourceMappingURL=permissionGroups.js.map